import React, { useEffect, useState } from 'react';
import { Col, Input, Popover, Radio, Row, Tabs } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import LoanTabDatas from './LoanTabDatas';
import '../../assets/Custom.css';
import SwitchBox from './SwitchBox';
import SortBy from './SortBy';
import { ServerAPI } from '../../common/ServerAPI';
import LoanSwitchBoxList from './LoanSwitchBoxList';
import PageLoader from '../../components/PageLoader';
import { useDispatch, useSelector } from 'react-redux';
import { setLoanApplicationFilter } from '../../redux/slice/loanFilterSlice';
import { useLocation } from 'react-router-dom';

const CaseList = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const pagePermission = location.state
  // console.log("pagePermission", pagePermission);
  const loanAppFilters = useSelector(
    (state) => state.loanProductFilter?.loanApplicationFilters
  );
  const [size, setSize] = useState('small');
  const [loading, setLoading] = useState(false);
  const [listDetails, setListDetails] = useState([]);
  const [tabIndex, settabIndex] = useState(0);
  const [tabTitle, settabTitle] = useState(
    Object.keys(loanAppFilters)?.length > 0 ? loanAppFilters?.filter : '1'
  );
  const [loanDetailName, setLoanDetailName] = useState('');
  const [searchText, setSearchText] = useState('');
  const { TabPane } = Tabs;
  const onChange = (e) => {
    setSize(e.target.value);
  };
  const [applyFilters, setApplyFilters] = useState(
    Object.keys(loanAppFilters)?.length > 0
      ? loanAppFilters
      : {
        sortKey: 'created_at', // name
        sortOrder: 'desc', // asc
        filter: '1',
        index: 0,
        provider_type: 'all',
        keyword: '',
      }
  );

  const LoanCaseList = async () => {
    //setLoading(true);
    const response = await ServerAPI.applicationList({
      ...applyFilters,
      provider_type:
        applyFilters?.provider_type === 'all'
          ? ''
          : applyFilters?.provider_type,
    });
    if (response) {
      if (response.data) {
        setLoading(false);
        setListDetails(response.data);
      }
    }
  };

  const handleSortBy = (val) => {
    switch (val) {
      case 'Most Recent':
        setApplyFilters({
          ...applyFilters,
          sortKey: 'created_at',
          sortOrder: 'desc',
        });
        dispatch(
          setLoanApplicationFilter({
            ...applyFilters,
            sortKey: 'created_at',
            sortOrder: 'desc',
          })
        );
        break;
      case 'Loan Amount Asc':
        setApplyFilters({
          ...applyFilters,
          sortKey: 'loanamount',
          sortOrder: 'asc',
        });
        dispatch(
          setLoanApplicationFilter({
            ...applyFilters,
            sortKey: 'loanamount',
            sortOrder: 'asc',
          })
        );

        break;
      case 'Loan Amount Dsc':
        setApplyFilters({
          ...applyFilters,
          sortKey: 'loanamount',
          sortOrder: 'desc',
        });
        dispatch(
          setLoanApplicationFilter({
            ...applyFilters,
            sortKey: 'loanamount',
            sortOrder: 'desc',
          })
        );
        break;
      default:
        break;
    }
  };

  const items = [
    {
      label: 'Pending',
      key: '1',
      children: <LoanTabDatas data={listDetails} type={'pending'} pagePermission={pagePermission} fetchLoanCase={LoanCaseList} />,
    },
    {
      label: 'Disbursement',
      key: '2',
      children: <LoanTabDatas data={listDetails} type={'disbursement'} pagePermission={pagePermission} fetchLoanCase={LoanCaseList} />,
    },
    {
      label: 'Expired',
      key: '3',
      children: <LoanTabDatas data={listDetails} type={'expired'} pagePermission={pagePermission} fetchLoanCase={LoanCaseList} />,
    },
  ];

  useEffect(() => {
    LoanCaseList();
  }, []);
  useEffect(() => {
    LoanCaseList();
  }, [applyFilters]);
  useEffect(() => {
    setApplyFilters({ ...applyFilters, filter: tabTitle, index: tabIndex });
    dispatch(
      setLoanApplicationFilter({
        ...applyFilters,
        filter: tabTitle,
        index: tabIndex,
      })
    );
  }, [tabTitle]);
  useEffect(() => {
    //console.log('loanDetailName', loanDetailName);
    setApplyFilters({ ...applyFilters, provider_type: loanDetailName });
    dispatch(
      setLoanApplicationFilter({
        ...applyFilters,
        provider_type: loanDetailName,
      })
    );
  }, [loanDetailName]);
  useEffect(() => {
    setApplyFilters({ ...applyFilters, keyword: searchText });
    dispatch(
      setLoanApplicationFilter({ ...applyFilters, keyword: searchText })
    );
  }, [searchText]);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className='w-full min-h-screen bg-[#F5F5F5] overflow-x-clip'>
      <div className='bg-white'>
        <div className='flex pt-[20px] justify-between items-center px-[24px] max-[600px]:flex-col max-[600px]:items-start'>
          <div className='flex items-baseline justify-between w-full md:w-fit'>
            <div className='font-[700] text-[20px] max-[600px]:mb-[15px]'>
              Loan Application
            </div>
            <div className='text-center md:hidden'>
              Credit(s):{' '}
              <span className='text-[#0660FC]'>
                5000
                <Popover content={'Coming soon'} className='mt-[-4px]'>
                  <img
                    src='/images/fi_info.svg'
                    alt='info'
                    className='inline-block ml-[8px] cursor-pointer'
                  />
                </Popover>
              </span>
            </div>
          </div>
          <div className='flex items-center max-[600px]:w-full'>
            <div className='relative w-[250px] max-w-[100%] max-[600px]:w-[100%]'>
              <div className='absolute h-[100%] top-[0] left-[0] flex items-center max-[768px]:left-[10px] max-[768px]:top-[-2px]'>
                <img
                  src='/images/search.svg'
                  alt='search'
                  className='pt-[3px]'
                />
              </div>
              <input
                type='search'
                placeholder='Search Product...'
                className='pl-[25px] outline-none text-[13px]  max-[768px]:border max-[768px]:border-gray-200 max-[768px]:p-[8px_20px_8px_33px] max-[768px]:rounded-[5px] max-[600px]:w-[100%]'
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
              />
              {/* <div
                className='h-[34px] w-[36px] bg-[#0560FB] hidden max-[600px]:inline-flex items-center justify-center rounded-[5px] ml-[10px] relative top-[2px]'
                onClick={() => {}}
              >
                <img
                  src='/images/filter_icon.png'
                  alt='filter'
                  className='max-w-[100%] h-auto'
                  width='14'
                  height='14'
                />
              </div> */}
            </div>
            <div className='text-center mr-5 hidden md:block'>
              Credit(s):{' '}
              <span className='text-[#0660FC]'>
                5000
                <Popover content={'Coming soon'} className='mt-[-4px]'>
                  <img
                    src='/images/fi_info.svg'
                    alt='info'
                    className='inline-block ml-[8px] cursor-pointer'
                  />
                </Popover>
              </span>
            </div>
          </div>
        </div>
        <div className='mx-5'>
          <LoanSwitchBoxList
            activeTabId={applyFilters.provider_type}
            handler={setLoanDetailName}
            tabs={[
              { name: 'All', dataKey: 'All', id: 'all' },
              {
                name: 'Bank',
                dataKey: 'Bank',
                id: '08469bdc-7b03-4f3f-8b34-7cc71d048640',
              },
              {
                name: 'Financial Institution',
                dataKey: 'Financial_Institution',
                id: '0bdb91a1-edca-4ec4-b298-30c431f38c2d',
              },
              {
                name: 'In-House',
                dataKey: 'In-House',
                id: 'eea49ff4-655f-412e-8bb2-22e0cf8578db',
              },
            ]}
          />
        </div>
        <div className='app-container p-[10px_25px]'>
          <Tabs
            defaultActiveKey={tabTitle}
            activeKey={tabTitle}
            onChange={(value) => {
              settabTitle(value);
              settabIndex(value - 1);
            }}
            items={items}
            tabBarExtraContent={
              <div className='sort-container'>
                <SortBy handleSortBy={handleSortBy} />
              </div>
            }
          ></Tabs>
        </div>
      </div>
    </div>
  );
};

export default CaseList;
